import { ReactNode } from "react";
import { useOktaAuth } from "@okta/okta-react";

interface AuthGateProps {
  children: ReactNode;
}

export default function AuthGate({
  children,
}: Readonly<AuthGateProps>): JSX.Element {
  const { authState, oktaAuth } = useOktaAuth();

  if (!authState) {
    return <div>Authenticating...</div>;
  }

  if (!authState.isAuthenticated) {
    oktaAuth.signInWithRedirect({
      originalUri: `${window.location.pathname}${window.location.search}${window.location.hash}`,
    });

    return <div>Redirecting to login...</div>;
  }

  return <>{children}</>;
}
